import React from 'react';
import { FaCheckCircle } from "react-icons/fa";
import '../styles/whoweare.scss';

const BenefitItem = ({ text }) => (
  <li className="benefit-item">
    <div className="check-circle">
      <FaCheckCircle />
    </div>
    <span>{text}</span>
  </li>
);

const WhoWeAre = () => (
  <section className="artiza-identity-section">
    <div className="identity-background-shape"></div>

    <div className="identity-container">
      {/* WHO WE ARE */}
      <div className="identity-mission">
        <p className="overline-text">WHO WE ARE</p>
        <h2 className="mission-heading">Artiza: Empowering Kenya’s Makers.</h2>
        <p className="mission-text">
          <strong>We are a digital platform that connects, dignifies, and celebrates Kenya’s artisans.</strong> 
          From carpenters to electricians, we bridge skilled makers with clients through technology, trust, 
          and storytelling — redefining how craftsmanship is experienced and valued.
        </p>
        {/* <a href="/about" className="learn-more-link">Learn More About Our Mission →</a> */}
      </div>

      {/* WHAT WE DO */}
      <div className="identity-services">
        <p className="overline-text">WHAT WE DO</p>
        <ul className="benefit-list">
          <BenefitItem text="Provide verified artisan profiles with reviews, photos, and skills." />
          <BenefitItem text="Connect homeowners and developers to trusted local talent." />
          <BenefitItem text="Use AI for smart matching and AR for real-time design visualization." />
          <BenefitItem text="Ensure fair pay, transparency, and quality at every step." />
        </ul>
        <a href="/login" className="cta-button">Hire an Artisan Today</a>
      </div>
    </div>
  </section>
);

export default WhoWeAre;
